import { render, staticRenderFns } from "./SupportingFile.vue?vue&type=template&id=379465e9&"
import script from "./SupportingFile.vue?vue&type=script&lang=js&"
export * from "./SupportingFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SupportingFile.vue"
export default component.exports